import React, { useState, useEffect } from "react";
import Swal from 'sweetalert2';
import { BASE_URL } from './apiConfig';
import { RotateSpinner } from "react-spinners-kit";
import '../Components/CommonCSS.css'

export default function Newipwhitelist() {
    const [ipAddress, setIpAddress] = useState("");
    const [ipList, setIpList] = useState([]);
    const [isValid, setIsValid] = useState(false);
    const [apikeyvalue, setapikeyvalue] = useState('');
    const [showprogress, setshowprogress] = useState(false);
    const [DistinctAPIData, setDistinctAPIData] = useState([]);

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
   const sessionusername = loginData?.guiuserid;

    const CallDistinctAPIKey = async () => {
        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctAPIKey`;
            const requestBody = {
                guiuserid: sessionusername,
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctAPIData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = JSON.parse(responseText);
            } else {
                data = [];
            }

            if (data?.length > 0) {
                setDistinctAPIData(data);
            } else {
                setDistinctAPIData([]);
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setDistinctAPIData([]);
            }
            return;
        }
    };

    const CallNewIPWhiteListing = async () => {
        setshowprogress(true);
        if (ipList.length === 0 || !apikeyvalue) {
            setshowprogress(false);
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please Fill in All Fields Values as Either API Key Value or New IP not inputted",
                icon: "error"
            })

          
        }

        else {
            const apiUrl = `${BASE_URL}/NewIPWhitelist`;
            const ips = ipList.join(',');
            console.log("IP comma Separeted:" + ips);
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    GenertaedSkey: apikeyvalue,
                    ipaddress: ips
                }),
            });

            if (!response.ok) {
                setshowprogress(false);
                const errorMessage = response.statusText;
                const responseBody = await response.text();
                setshowprogress(false);
                const result = await Swal.fire({
                    title: 'IP Whitelisting Error',
                    html: `${errorMessage}${responseBody}`,
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setapikeyvalue('');
                    setIpList([]);
                }
                return;
            }

            else {
                setshowprogress(false);
                const result = await Swal.fire({
                    title: "IP Mapped Successfully!",
                    text: `Successfully Mapped ${ips} with API Key ${apikeyvalue}`,
                    icon: "success"
                });
                if (result.isConfirmed) {
                    setapikeyvalue('');
                    setIpList([]);
                }
            }
        }
    };

    // Regular expression to validate a full IP address
    const ipPattern = /^(?:(?:\d{1,3})\.){3}(?:\d{1,3})$/;

    const handleInputChange = (event) => {
        let value = event.target.value;

        // Check if each segment has 1-3 digits, the total format is correct,
        // and no part starts with a leading zero unless it's "0" alone.
        const parts = value.split('.');
        if (
            parts.length > 4 ||
            parts.some(part => part.length > 3 || isNaN(part) || (part.length > 1 && part.startsWith('0')))
        ) {
            return; // Ignore invalid input
        }

        // Update the IP address and validate it only if all 4 parts are present
        setIpAddress(value);
        setIsValid(ipPattern.test(value));
    };

    const handleKeyDown = (event) => {
        const allowedKeys = [
            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
        ];

        // Allow digits and dots, with additional restrictions on the dot
        if (
            allowedKeys.includes(event.key) || // Allow control/navigation keys
            (event.key >= '0' && event.key <= '9') || // Allow digits
            (event.key === '.' && ipAddress && !ipAddress.endsWith('.') && ipAddress.split('.').length < 4) // Allow dots if conditions met
        ) {
            return; // Allow key
        }

        event.preventDefault(); // Prevent other inputs
    };


    const handleAddIp = () => {
        if (isValid) {
            setIpList([...ipList, ipAddress]);
            setIpAddress("");
            setIsValid(false);
        }
    };
    console.log(ipList)

        // const ipe = ips.split(','); // This will split the string at each comma
        // console.log(ipe); 
        ;

    console.log("apikeyvalue:" + apikeyvalue);

    useEffect(() => {
        CallDistinctAPIKey();
    }, []);
    return (
        <div className="maincontent-outermost">
            <div className="div-container">
                <div className="row-container">
                    <span>New IP Whitelisting</span>
                </div>

                <div className="row-container">
                    <div className="row-left-div" style={{ position: "relative" }}>
                        {showprogress === true ? <div className="spinner-overlay">
                                <div className="custom-spinner"></div>
                            </div> : <div></div>}

                        <div className={showprogress === true ? "div blurred" : "div"}>
                            <img src="/images/UTunne.webp" className="imgclass"/>
                            
                            <div className="row-container">
                                <div style={{width:"100%", }}>
                                    <label style={{ fontWeight: "600" }} className="label">User API Key</label>
                                    <div style={{ display: "flex" }} className="inp">
                                        <select
                                            className="selectpicker form-control"
                                            value={apikeyvalue}
                                            onChange={(e) => setapikeyvalue(e.target.value)}
                                            style={{ fontSize: "0.8rem", textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                        >
                                            <option value="" disabled>Select API Key</option>
                                            {DistinctAPIData?.map((option, index) => (
                                                <option
                                                    key={index}
                                                    value={option?.genertaedSkey}

                                                    style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap", marginLeft: "-1rem" }}
                                                >
                                                    {option?.genertaedSkey}
                                                </option>
                                            ))}
                                        </select>
                                        <div style={{ alignItems: "center", border: "1px solid rgb(179, 176, 176)", backgroundColor: "rgb(179, 176, 176)", justifyContent: "center", padding: "0rem 0.5rem" }} className="ic-div">
                                            <i className="fa-solid fa-key"></i>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div className="row-container mt-3">
                                <div>
                                    <label style={{ fontWeight: "600" }} className="label">IP Address</label>
                                    <div style={{ display: "flex" }} className="inputter" >
                                    <input
                                            type="text"
                                            id="ipAddress"
                                            value={ipAddress}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyDown}
                                            placeholder="e.g., 192.168.1.1"
                                            style={{ fontSize: "0.9rem" }}
                                            className="form-control "
                                        />

<button
                                            onClick={handleAddIp}
                                            disabled={!isValid}
                                            style={{
                                                backgroundColor: isValid ? "greenyellow" : "lightgray",
                                                border: isValid ? "1px solid greenyellow" : "1px solid lightgray",
                                                padding: "0rem 0.2rem",
                                                cursor: isValid ? "pointer" : "not-allowed"
                                            }}
                                        >
                                            <i class="fa-solid fa-circle-plus" style={{ fontSize: "0.8rem", padding: "0rem 0.1rem" }}></i><span style={{ fontSize: "0.8rem", padding: "0rem 0.1rem" }}>Add IP</span>
                                        </button>
                                    </div>

                                    <div
                                        style={{
                                            
                                            overflowY: "auto",
                                            minHeight: "40px",
                                            maxHeight: "120px", // Just to ensure the div has some height
                                            border: "1px solid #ccc",
                                            padding: "3px 10px",
                                            whiteSpace: "pre-wrap", // Ensure each IP address is on a new line
                                            wordBreak: "break-word", // Handle long IP addresses

                                        }}
                                    >
                                        {ipList.length === 0 ? (
                                            <div style={{ fontSize: "0.8rem", height: "40px", display: "flex", alignItems: "center", marginTop: "-3px", marginBottom: "-3px" }}>No New IP Added Yet</div>
                                        ) : (
                                            ipList.map((ip, index) => (
                                                <div key={index}><span style={{ fontSize: "0.9rem", color: "gray" }}>{ip}</span></div>
                                            ))
                                        )}


                                    </div>
                                </div>
                            </div>

                            <div className="row-container my-4" style={{ justifyContent: "center", marginLeft:"-1rem" }}>
                                <button type="submit" className="btn  btn-info  " onClick={CallNewIPWhiteListing}>Add New IP Address
                                    <img src="images/newcomp.png" style={{ height: "1.4rem", width: "1.4rem" }} className="ml-1" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row-right-div" >
                        <img src="images/ipaddressicon.jpeg" />
                    </div>
                </div>
            </div>
        </div>
    );
}